module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAQElEQVRIiWP8//8/AxEAlyJGQhqZiDGdEjBqwagFQ8ACFgbcmYgYQFDv0A+iUQsIAhYGIopchtHietSCUQsoAgBiXgcwBtnhAwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/ui/InfoOpenIcon.png
// module id = NACn
// module chunks = 1